import Breadcrumb from "./Breadcrumb/BreadCrumb";
import Sidebar from "./Sidebar/Sidebar";

const Layout = ({ children }) => {
  return (
    <div className="main-screen">
      <Sidebar />
      <Breadcrumb />
      <div className="device-list component-wrapper">{children}</div>
    </div>
  );
};

export default Layout;
